import { Button } from "antd";
import React, { useState } from "react";
import { EditWorkingDaysModal } from "./EditWorkingDaysModal";

export const EDIT_WORKING_DAYS_TXT = "Edit Working Days";

type Props = {
  customer: string;
  project: string;
  workingDays: number[] | null | undefined;
};

export const EditWorkingDaysButton = (props: Props) => {
  const { customer, project, workingDays } = props;
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Button onClick={() => setModalVisible(true)}>
        {EDIT_WORKING_DAYS_TXT}
      </Button>
      <EditWorkingDaysModal
        customer={customer}
        project={project}
        workingDays={workingDays}
        visible={modalVisible}
        setVisible={setModalVisible}
      />
    </>
  );
};
